module.exports = "<div class=\"counter__container\" *ngIf=\"(nrDoneJobs$ | async) > 0\" title=\"{{(nrDoneJobs$ | async)}} Bericht(e) sind bereit zum Herunterladen.\">\n    <span class=\"counter\">{{nrDoneJobs$ | async}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/download-status/counter-done-reports/counter-done-reports.html
// module id = gJ2R
// module chunks = 12